import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import ProjectCard from './ProjectCard';

export default function Projects() {
    const [isLoading, setIsLoading] = useState(true);
    const [projects, setProjects] = useState();
    useEffect(() => {
        fetch('projectsData.json')
            .then(res => res.json())
            .then(data => {
                setIsLoading(false)
                setProjects(data);
            })
    }, [])

    return (
        <div className='my-20 mx-12'>
            <div className='flex justify-center gap-2 items-center mb-8 md:mb-16'>
                <div className=' w-12 h-0.5 bg-white'></div>
                <h3 className=' text-white font-bold lg:text-3xl md:text-2xl text-lg text-center'>Recent Projects</h3>
                <div className=' w-12 h-0.5 bg-white'></div>
            </div>
            <div className=' grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
                {
                    isLoading ? <div className=' text-center'>Loading..</div>
                        :
                        projects.map(project => <ProjectCard key={project._id} project={project} />)

                }
            </div>


        </div>
    )
}
